import { forwardRef } from "react";
import { useValidation } from "@/shared/forms";
import type { NumberFiled } from "./types";

export const NumberField = forwardRef<HTMLInputElement, NumberFiled>(function NumberField(
    {
        id,
        ariaLabel,
        value,
        onKeyDown,
        onChange,
        required = false,
        validationPattern = "number",
        customValidation,
        ...rest
    },
    ref,
) {
    useValidation(id, {
        errorLocation: "callout",
        rules: {
            required,
            year: validationPattern === "year",
            number: validationPattern === "number",
            ...(customValidation && { custom: customValidation }),
        },
    });

    return (
        <input
            id={id}
            type="number"
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            required={required}
            aria-label={ariaLabel}
            ref={ref}
            {...rest}
        />
    );
});
